import { useGetOne } from 'react-admin';
import { AVATARS } from '@/utils/CONST';
import { Avatar } from '@/utils/types';

interface Params {
    avatarUriId: string | undefined | null;
    filters?: {
        [key: string]: string | string[]
    }
    queryKey?: string;
}

interface Output {
    avatar: Avatar;
    isLoading: boolean;
    refetch: any;
}

const useGetAvatar = ({ avatarUriId, filters, queryKey = AVATARS }: Params): Output => {
    const { data, isLoading, refetch }: any = useGetOne(
        queryKey,
        {
            id: avatarUriId,
            meta: {
                realResource: AVATARS,
                filters: filters,
            },
        },
        {
            enabled: avatarUriId !== undefined && avatarUriId !== null
        },
    );

    return {
        avatar: data,
        isLoading,
        refetch,
    };
};

export default useGetAvatar;
